var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTransact = function SvgTransact(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 20 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "transact")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    className: "svg-hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Home",
    transform: "translate(-34.000000, -544.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transact",
    transform: "translate(32.000000, 539.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "svg-hover",
    id: "Cash-Money",
    transform: "translate(3.000000, 6.000000)",
    stroke: "var(--primaryTextColor)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0909091,3.27272727 L13.0909091,1.63636364 C13.0909091,0.732624545 12.3583091,0 11.4545455,0 L1.63636364,0 C0.732624545,0 0,0.732624545 0,1.63636364 L0,6.54545455 C0,7.44921818 0.732624545,8.18181818 1.63636364,8.18181818 L4.79220545,8.18181818",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.90909091,
    y: 3.27272727,
    width: 13.0909091,
    height: 8.18181818,
    rx: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.4545455,
    cy: 7.36363636,
    r: 1.63636364
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transact.da385529.svg";
export { ForwardRef as ReactComponent };